

const FinanceData = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Jan Dhan Yojana",
        discription:"Pradhan Mantri Jan Dhan Yojana (PMJDY), one of the biggest financial inclusion initiatives in the world, was announced by Prime Minister, Shri Narendra Modi on 15th August 2014 from the ramparts of the Red Fort.",
        launchDate: "28 August 2014",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Pradhan Mantri Jeevan Jyoti  Bima Yojana",
    discription:"Pradhan Mantri Jeevan Jyoti Bima Yojana (english translation: Prime Minister Jeevan Jyoti Insurance Scheme) is a government-backed Life insurance scheme in India.",
    launchDate: "9 may 2015",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Pradhan Mantri Suraksha Bima Yojana",
    discription:"The Pradhan Mantri Suraksha Bima Yojana is a beneficial scheme that is particularly initiated to get the uninsured people into the normal insurance services facilities..",
    launchDate: "9 may 2015",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Atal Pension Yojana",
        discription:"Atal Pension Yojana (APY), a pension scheme for citizens of India is focused on the unorganized sector workers. Under the APY, guaranteed minimum pension of Rs. 1,000/- or 2,000/- or 3,000/- or 4,000 or 5,000/- per month will be given at the age of 60 years depending on the contributions by the subscribers. Any Citizen of India can join APY scheme",
        launchDate: "9 may 2015",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Gold Monetisation Scheme",
    discription:"According to the World Gold Council Report, the country’s gold demand stood at 974.8 tonnes in 2013, wherein a significant amount of gold was imported to meet this demand. Between 2009-10 and 2012-13, gold imports accounted for ~30% India's trade deficit. ",
    launchDate: "4 November", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: " Kisan Vikas Patra ",
    discription:"According to the World Gold Council Report, the country’s gold demand stood at 974.8 tonnes in 2013, wherein a significant amount of gold was imported to meet this demand. Between 2009-10 and 2012-13, gold imports accounted for ~30% India's trade deficit. ",
    launchDate: "Year 2014",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Pradhan Mantri Garib Kalyan Yojana",
discription:"The Pradhan Mantri Garib Kalyan Yojana / Package is a comprehensive relief package of Rs 1.70 Lakh Crore Yojana for the poor to help them fight the battle against Corona Virus. ",
launchDate: "16 December 2016",
AnualFund: "12345"},





]
export default FinanceData